import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import Navdata from '../LayoutMenuData';
import { useLayoutContext } from '../../context/LayoutContext';

const VerticalLayout = () => {
  const navData = Navdata().props.children;
  const { layoutState } = useLayoutContext();
  const { leftsidbarSizeType, sidebarVisibilitytype, layoutType } = layoutState;
  const location = useLocation();

  // مدیریت تغییر اندازه sidebar در حالت‌های مختلف
  const resizeSidebarMenu = useCallback(() => {
    const windowSize = document.documentElement.clientWidth;
    if (windowSize >= 1025) {
      document.documentElement.setAttribute('data-sidebar-size', leftsidbarSizeType);
      const hamburgerIcon = document.querySelector('.hamburger-icon');
      if (sidebarVisibilitytype === 'show' || layoutType === 'vertical') {
        hamburgerIcon?.classList.remove('open');
      } else {
        hamburgerIcon?.classList.add('open');
      }
    } else if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove('vertical-sidebar-enable');
      document.documentElement.setAttribute('data-sidebar-size', 'sm');
      document.querySelector('.hamburger-icon')?.classList.add('open');
    } else if (windowSize <= 767) {
      document.body.classList.remove('vertical-sidebar-enable');
      document.documentElement.setAttribute('data-sidebar-size', 'lg');
      document.querySelector('.hamburger-icon')?.classList.add('open');
    }
  }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

  useEffect(() => {
    window.addEventListener('resize', resizeSidebarMenu);
    resizeSidebarMenu();
    return () => window.removeEventListener('resize', resizeSidebarMenu);
  }, [resizeSidebarMenu]);

  // فعال‌سازی منوی فعلی
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const initMenu = () => {
      const pathName = location.pathname;
      const ul = document.getElementById('navbar-nav');
      const items = ul.getElementsByTagName('a');
      const itemsArray = [...items];
      removeActivation(itemsArray);
      const matchingMenuItem = itemsArray.find((x) => x.pathname === pathName);
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [location.pathname]);

  const activateParentDropdown = (item) => {
    item.classList.add('active');
    let parentCollapseDiv = item.closest('.collapse.menu-dropdown');
    while (parentCollapseDiv) {
      parentCollapseDiv.classList.add('show');
      parentCollapseDiv.parentElement.children[0].classList.add('active');
      parentCollapseDiv.parentElement.children[0].setAttribute('aria-expanded', 'true');
      parentCollapseDiv = parentCollapseDiv.parentElement.closest('.collapse.menu-dropdown');
    }
  };

  const removeActivation = (items) => {
    items.forEach((item) => {
      if (item.classList.contains('menu-link') || item.classList.contains('nav-link')) {
        item.setAttribute('aria-expanded', 'false');
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove('show');
        }
        item.classList.remove('active');
      }
    });
  };

  return (
    <ul className="navbar-nav" id="navbar-nav">
      {navData.map((item, key) => (
        <React.Fragment key={key}>
          {item.isHeader ? (
            <li className="menu-title">
              <span>{item.label}</span>
            </li>
          ) : item.subItems ? (
            <li className="nav-item">
              <Link
                onClick={item.click}
                className="nav-link menu-link"
                to={item.link || '#'}
                data-bs-toggle="collapse"
                aria-expanded={item.stateVariables}
              >
                {item.icon} <span>{item.label}</span>
              </Link>
              <Collapse
                className="menu-dropdown"
                isOpen={item.stateVariables}
                id={`sidebar-${item.id}`}
              >
                <ul className="nav nav-sm flex-column">
                  {item.subItems.map((subItem, subKey) => (
                    <React.Fragment key={subKey}>
                      {!subItem.isChildItem ? (
                        <li className="nav-item">
                          <Link to={subItem.link || '#'} className="nav-link">
                            {subItem.label}
                            {subItem.badgeName && (
                              <span className={`badge badge-pill bg-${subItem.badgeColor}`}>
                                {subItem.badgeName}
                              </span>
                            )}
                          </Link>
                        </li>
                      ) : (
                        <li className="nav-item">
                          <Link
                            onClick={subItem.click}
                            className="nav-link"
                            to="#"
                            data-bs-toggle="collapse"
                            aria-expanded={subItem.stateVariables}
                          >
                            {subItem.label}
                            {subItem.badgeName && (
                              <span className={`badge badge-pill bg-${subItem.badgeColor}`}>
                                {subItem.badgeName}
                              </span>
                            )}
                          </Link>
                          <Collapse
                            className="menu-dropdown"
                            isOpen={subItem.stateVariables}
                            id={`sidebar-${subItem.id}`}
                          >
                            <ul className="nav nav-sm flex-column">
                              {subItem.childItems.map((childItem, childKey) => (
                                <li className="nav-item" key={childKey}>
                                  <Link to={childItem.link || '#'} className="nav-link">
                                    {childItem.label}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </Collapse>
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              </Collapse>
            </li>
          ) : (
            <li className="nav-item">
              <Link className="nav-link menu-link" to={item.link || '#'}>
                {item.icon} <span>{item.label}</span>
                {item.badgeName && (
                  <span className={`badge badge-pill bg-${item.badgeColor}`}>
                    {item.badgeName}
                  </span>
                )}
              </Link>
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
};

export default VerticalLayout;